import API from "../../../api"
import { useQuery } from "@tanstack/react-query";
import { Content } from "../entity";

export const useCmsContent = (contentGuid) =>
  useQuery({
    queryKey: ["cmsContent", contentGuid],
    queryFn: () => API.Content.getObjects({
      contentIds: contentGuid
    }).then(({ data }) => Content(data.data[0])),
    enabled: !!contentGuid,
    staleTime: Infinity,
  })

export const useSimilarToContent = (contentGuid, n) =>
  useQuery({
    queryKey: ["similarToContent", contentGuid, n],
    queryFn: () => API.Content.getSimilarTo({
      guid: contentGuid,
      n,
    }).then(({ data }) => data.data.map(Content)),
    enabled: !!contentGuid,
    staleTime: Infinity,
  })
